import React from 'react';

const HorizontalPump3Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 49.211"
      className={className}
    >

<g id={`${uid}_1`}>
	
		<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="87.8379" y1="3.6035" x2="87.8379" y2="45.7202" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} stroke={`${startColor}`} strokeWidth="0.25" d="M107.771,45.607V3.491H93.807v10.585h-9.459v2.252H67.904   V32.77h16.441v2.252h9.461v10.586H107.771z" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M93.807,35.021V14.077" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M84.348,32.77v-16.44" />
	<path fill={`${startColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M93.807,30.518l-4.729-1.352v-8.784l4.729-1.802V30.518z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M93.807,17.455v1.352l-4.729,1.576v-1.126L93.807,17.455z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M93.807,30.293v1.352l-4.729-1.127v-1.352L93.807,30.293z" />
</g>
<g id={`${uid}_3`}>
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M82.096,20.383H69.031v11.262h13.063V20.383H82.096z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M82.096,31.645V20.383H69.031" />
</g>
<g id={`${uid}_4`}>
	<linearGradient id={`${uid}_5`} gradientUnits="userSpaceOnUse" x1="94.9336" y1="2.9282" x2="106.6445" y2="2.9282">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_5)`} d="M106.645,2.365H94.934v1.126h11.711V2.365z" />
	
		<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="89.0762" y1="48.0283" x2="112.5" y2="48.0283" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} stroke={`${startColor}`} strokeWidth="0.25" d="M112.5,0H89.076v2.365H112.5V0" />
</g>
<g id={`${uid}_7`}>
	
		<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="93.8066" y1="1.2388" x2="107.7715" y2="1.2388" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} stroke={`${startColor}`} strokeWidth="0.25" d="M107.771,46.733H93.807v2.478h13.965V46.733z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M107.771,46.734V42.23l-6.982,4.504l-6.98-4.504v4.504H107.771z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M102.59,37.5h-3.604v9.234h3.604V37.5z" />
</g>
<g id={`${uid}_9`}>
	
		<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="70.3828" y1="8.7832" x2="73.7617" y2="8.7832" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} stroke={`${startColor}`} strokeWidth="0.25" d="M73.762,32.77h-3.379v15.316h3.379V32.77z" />
	
		<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="69.707" y1="8.2207" x2="74.8867" y2="8.2207" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} stroke={`${startColor}`} strokeWidth="0.25" d="M74.887,32.77v16.441h-5.18v-1.125l4.055-0.676V32.77H74.887z   " />
</g>
<g id={`${uid}_12`}>
	
		<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="55.0664" y1="20.0439" x2="55.0664" y2="29.2778" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.07" style={{stopColor: `${endColor}`}} />
		<stop offset="0.49" style={{stopColor: `${midColor}`}} />
		<stop offset="0.99" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} stroke={`${startColor}`} strokeWidth="0.25" d="M67.904,19.933H42.229v9.234h25.675V19.933z" />
	<path fill={`${startColor}`} d="M59.121,21.734h-8.107v4.504h8.107V21.734z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M59.121,22.86h-8.107" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M59.121,23.987h-8.107" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M59.121,25.113h-8.107" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M57.32,26.239v-4.504" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M54.842,26.239v-4.504" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M52.59,26.239v-4.504" />
</g>
<g id={`${uid}_14`}>
	
		<linearGradient id={`${uid}_15`} gradientUnits="userSpaceOnUse" x1="22.1851" y1="14.1895" x2="22.1851" y2="35.1343" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_15)`} stroke={`${startColor}`} strokeWidth="0.25" d="M42.229,14.077H2.14v20.944h40.09L42.229,14.077   L42.229,14.077z" />
	<path fill={`${startColor}`} d="M35.022,14.077H11.599v20.944h23.423V14.077z" />
</g>
<g id={`${uid}_16`}>
	<path d="M40.428,35.021H3.491V37.5h36.937V35.021z" fill={`${midColor}`} />
	<path fill={`${midColor}`} d="M35.022,25.789H11.599v2.252h23.423V25.789z" />
	<path fill={`${midColor}`} d="M35.022,21.059H11.599v2.252h23.423V21.059z" />
	<path fill={`${endColor}`} d="M35.022,29.842H11.599v2.252h23.423V29.842z" />
	<path fill={`${endColor}`} d="M35.022,17.005H11.599v2.252h23.423V17.005z" />
	<path fill={`${endColor}`} d="M35.022,33.896H11.599v2.478h23.423V33.896z" />
	<path fill={`${endColor}`} d="M35.022,12.951H11.599v2.252h23.423V12.951z" />
</g>
<g id={`${uid}_17`}>
	
		<linearGradient id={`${uid}_18`} gradientUnits="userSpaceOnUse" x1="4.6172" y1="11.7109" x2="11.5991" y2="11.7109" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_18)`} d="M11.599,36.374H4.617v2.252h6.982V36.374z" />
	
		<linearGradient id={`${uid}_19`} gradientUnits="userSpaceOnUse" x1="35.022" y1="11.7109" x2="42.229" y2="11.7109" gradientTransform="matrix(1 0 0 -1 0 49.2109)">
		<stop offset="0.01" style={{stopColor: `${startColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_19)`} d="M42.229,36.374h-7.207v2.252h7.207V36.374z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M44.482,38.625H0v10.586h44.482V38.625z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M44.482,49.211V38.625H0" />
</g>
    </svg>
  );
};

export default HorizontalPump3Icon;
